import { useGetHseDesignContexts } from "./useGetHseDesignContexts";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { AppTester } from "../../../../supporting";
import { useGetGalllleryContexts } from "./useGetGalllleryContexts";
import { useGetHseSpaceContext } from "./useGetHseSpaceContext";
import { useGetDafesContexts } from "./useGetDafesContexts";
import { useRouteMatch } from "react-router-dom";
import { useGetRussianGalllleryContexts } from "./useGetRussianGalllleryContexts";
import { useCreativeContexts } from "./useCreativeContexts";
import { useFrenchContexts } from "./useFrenchContexts";
import { useOnlinesDesignContexts } from "./useOnlinesDesignContexts";
import { useGetNewContextsLinks } from "./useGetNewContextsLinks";

interface ContextLinks {
    links: any[];
    modalSettings: {
        title: string;
        titleColor: string;
    }
}

const EMPTY_CONTEXT_LINKS: ContextLinks = {
    links: [],
    modalSettings: {
        title: '',
        titleColor: ''
    }
}

interface UseContextLinksNewProps {
    isOnlyMediaContext?: boolean; // пропс для фильтрации только mediiia
    excludeIds?: string[];
}

export const useContextLinksNew = (props?: UseContextLinksNewProps) => {
    const { isOnlyMediaContext, excludeIds } = props || {};
    const {
        isAKI,
        isMediiia,
        isFashionDeziiign,
        isGameDeziiign,
        isProDeziiign,
        isDeziiign,
        isHSEDesign,
        isAgeytomesh,
        isDvaDesign,
        isGalllleryArt,
        isOnlines,
        isOnlinesDesign,
        isSchool,
        isBrnd,
        isGeoDafes: isDafes,
        isCGRAVE,
        isPortfolio365,
        isHseColors,
        isBooksGallllery,
        isContinuumSite,
        isCompetition: isCompetitionDeziiign,
        isLMSHSECreative,
        isHseSpace,
        isHseAnimation,
        isNewDafesSegment,
        isAcademy,
        isFr,
        isUz,
    } = useAppTester()

    const isBooks = AppTester.isBooks();


    const isRussianGalllleryRoute = !!useRouteMatch('/teams/russiangallllery')
    const isRussianGalllery = isBooksGallllery && isRussianGalllleryRoute

    const hseDesignContexts = useGetHseDesignContexts()
    const galllleryContexts = useGetGalllleryContexts()
    const hseSpaceContexts = useGetHseSpaceContext();
    const dafesContexts = useGetDafesContexts();
    const russianGalllleryLinks = useGetRussianGalllleryContexts()
    const creativeContexts = useCreativeContexts()
    const frenchContexts = useFrenchContexts();
    const onlinesDesignContexts = useOnlinesDesignContexts();
    const newContextsLinks = useGetNewContextsLinks({onlyMediiia: isOnlyMediaContext, excludeIds: excludeIds});
    if (
        isAgeytomesh
        // || isHseAnimation
        || isDvaDesign
        || isGalllleryArt
        // || isBrnd
        // || isContinuumSite
        || isOnlines
        || isSchool
        || isPortfolio365
        || isLMSHSECreative
        || isUz
        || isAKI
        // || isAcademy
    ) return EMPTY_CONTEXT_LINKS;

    if (isOnlinesDesign) return onlinesDesignContexts
    if (isFr) return frenchContexts
    if (isRussianGalllery) return russianGalllleryLinks
    if (isBooksGallllery) return galllleryContexts
    if (isNewDafesSegment) return dafesContexts
    if (isHseSpace) return hseSpaceContexts
    if (isHSEDesign && !isHseColors) return hseDesignContexts
    // if (isMediiia) return mediaContexts
    if (isAKI /*|| isAcademy*/) return creativeContexts
    if ((isBooks || isFashionDeziiign || isDafes || isAcademy || isBrnd || isContinuumSite || isGameDeziiign || isProDeziiign || isDeziiign || isCompetitionDeziiign || isHseAnimation) /*&& !isCGRAVE*/) return newContextsLinks
    return EMPTY_CONTEXT_LINKS;
}import { useGetHseDesignContexts } from "./useGetHseDesignContexts";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { AppTester } from "../../../../supporting";
import { useGetGalllleryContexts } from "./useGetGalllleryContexts";
import { useGetHseSpaceContext } from "./useGetHseSpaceContext";
import { useGetDafesContexts } from "./useGetDafesContexts";
import { useRouteMatch } from "react-router-dom";
import { useGetRussianGalllleryContexts } from "./useGetRussianGalllleryContexts";
import { useCreativeContexts } from "./useCreativeContexts";
import { useFrenchContexts } from "./useFrenchContexts";
import { useOnlinesDesignContexts } from "./useOnlinesDesignContexts";
import { useGetNewContextsLinks } from "./useGetNewContextsLinks";

interface ContextLinks {
    links: any[];
    modalSettings: {
        title: string;
        titleColor: string;
    }
}

const EMPTY_CONTEXT_LINKS: ContextLinks = {
    links: [],
    modalSettings: {
        title: '',
        titleColor: ''
    }
}

interface UseContextLinksNewProps {
    isOnlyMediaContext?: boolean; // пропс для фильтрации только mediiia
    excludeIds?: string[];
}

export const useContextLinksNew = (props?: UseContextLinksNewProps) => {
    const { isOnlyMediaContext, excludeIds } = props || {};
    const {
        isAKI,
        isMediiia,
        isFashionDeziiign,
        isGameDeziiign,
        isProDeziiign,
        isDeziiign,
        isHSEDesign,
        isAgeytomesh,
        isDvaDesign,
        isGalllleryArt,
        isOnlines,
        isOnlinesDesign,
        isSchool,
        isBrnd,
        isGeoDafes: isDafes,
        isCGRAVE,
        isPortfolio365,
        isHseColors,
        isBooksGallllery,
        isContinuumSite,
        isCompetition: isCompetitionDeziiign,
        isLMSHSECreative,
        isHseSpace,
        isHseAnimation,
        isNewDafesSegment,
        isAcademy,
        isFr,
        isUz,
    } = useAppTester()

    const isBooks = AppTester.isBooks();


    const isRussianGalllleryRoute = !!useRouteMatch('/teams/russiangallllery')
    const isRussianGalllery = isBooksGallllery && isRussianGalllleryRoute

    const hseDesignContexts = useGetHseDesignContexts()
    const galllleryContexts = useGetGalllleryContexts()
    const hseSpaceContexts = useGetHseSpaceContext();
    const dafesContexts = useGetDafesContexts();
    const russianGalllleryLinks = useGetRussianGalllleryContexts()
    const creativeContexts = useCreativeContexts()
    const frenchContexts = useFrenchContexts();
    const onlinesDesignContexts = useOnlinesDesignContexts();
    const newContextsLinks = useGetNewContextsLinks({onlyMediiia: isOnlyMediaContext, excludeIds: excludeIds});
    if (
        isAgeytomesh
        // || isHseAnimation
        || isDvaDesign
        || isGalllleryArt
        // || isBrnd
        // || isContinuumSite
        || isOnlines
        || isSchool
        || isPortfolio365
        || isLMSHSECreative
        || isUz
        || isAKI
        // || isAcademy
    ) return EMPTY_CONTEXT_LINKS;

    if (isOnlinesDesign) return onlinesDesignContexts
    if (isFr) return frenchContexts
    if (isRussianGalllery) return russianGalllleryLinks
    if (isBooksGallllery) return galllleryContexts
    if (isNewDafesSegment) return dafesContexts
    if (isHseSpace) return hseSpaceContexts
    if (isHSEDesign && !isHseColors) return hseDesignContexts
    // if (isMediiia) return mediaContexts
    if (isAKI /*|| isAcademy*/) return creativeContexts
    if ((isBooks || isFashionDeziiign || isDafes || isAcademy || isBrnd || isContinuumSite || isGameDeziiign || isProDeziiign || isDeziiign || isCompetitionDeziiign || isHseAnimation) /*&& !isCGRAVE*/) return newContextsLinks
    return EMPTY_CONTEXT_LINKS;
}